<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-toast></p-toast>
<div class="card">
  <div class="text-xl font-bold mb-2">
    <label>Buscar Principio Activo</label>
  </div>
  <p-autoComplete
    [(ngModel)]="selectedActiveIngredient"
    [virtualScroll]="true"
    [suggestions]="filteredActiveIngredients"
    [itemSize]="34"
    (completeMethod)="filterActiveIngredients($event)"
    [dropdown]="true"
    (onSelect)="onSelectedActiveIngredient($event)"
    class="mr-4"
  >
  </p-autoComplete>

  <button
    [disabled]="!selectedActiveIngredient"
    (click)="searchByActiveIngredient()"
    pButton
    pRipple
    pTooltip="Buscar por principio activo"
    type="button"
    icon="pi pi-search"
    class="mr-2 p-button-rounded p-button-success"
  ></button>
  <button
    (click)="clearFilter()"
    pButton
    pRipple
    pTooltip="Limpiar filtro"
    type="button"
    icon="pi pi-times"
    class="p-button-rounded p-button-danger"
  ></button>
</div>

<ami-table-expansion
  [settings]="table.settings"
  [data]="filteredTableData"
  [childSettings]="tableChild.settings"
  [childActions]="tableChild.actions"
  (childAction)="onReciveActionChild($event)"
  [showSearchHelpersOfChild]="false"
>
</ami-table-expansion>
<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>

<p-dialog
  header="Conflicto en Abrir presentacion de venta"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '17vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <p class="m-0">No existe Subformato y/o No hay stock</p>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (click)="displayModal = false"
      label="Ok"
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>

<ng-container *ngIf="openSideBar">
  <pg-product-sale-sidebar
    type="new"
    [item]="itemToSideBar"
    (close)="openSideBar = false"
  ></pg-product-sale-sidebar>
</ng-container>
